/* AROMALA — theme interactions (vanilla JS, no framework). */
(function () {
  'use strict';
  var CFG = window.AROMALA || {};

  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(){
    var els = [].slice.call(document.querySelectorAll('[data-reveal]'));
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-visible');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){
          var d = parseInt(en.target.getAttribute('data-reveal-delay')||'0',10);
          setTimeout(function(){ en.target.classList.add('is-visible'); }, d);
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.08 });
    els.forEach(function(e){ io.observe(e); });
    // Safety: force reveal after 1.4s so content is never stuck hidden
    setTimeout(function(){ els.forEach(function(e){ e.classList.add('is-visible'); }); }, 1400);
  }

  /* ---------- Sticky nav frost ---------- */
  function initNavFrost(){
    var nav = document.getElementById('aro-nav');
    if(!nav) return;
    var isHome = nav.classList.contains('aro-nav-home');
    function onScroll(){
      var scrolled = window.scrollY > 60;
      nav.classList.toggle('is-scrolled', scrolled);
      if(isHome){
        nav.style.padding = scrolled ? '16px 48px' : '22px 48px';
      }
    }
    window.addEventListener('scroll', onScroll, { passive:true }); onScroll();
  }

  /* ---------- Hero parallax + float ---------- */
  function initHero(){
    var img = document.getElementById('aro-hero-img');
    if(!img) return;
    img.style.animation = 'aroFloat 9s ease-in-out infinite';
    window.addEventListener('scroll', function(){
      var y = window.scrollY;
      if(y < window.innerHeight * 1.2){ img.style.transform = 'translateY(' + (y * 0.12) + 'px)'; }
    }, { passive:true });
  }

  /* ---------- Magnetic buttons ---------- */
  function initMagnetic(){
    [].slice.call(document.querySelectorAll('[data-magnetic]')).forEach(function(el){
      el.addEventListener('mousemove', function(e){
        var r = el.getBoundingClientRect();
        var mx = e.clientX - r.left - r.width/2;
        var my = e.clientY - r.top - r.height/2;
        el.style.transform = 'translate(' + (mx*0.28) + 'px,' + (my*0.4) + 'px)';
      });
      el.addEventListener('mouseleave', function(){ el.style.transform = 'translate(0,0)'; });
    });
  }

  /* ---------- Accordions (single-open) ---------- */
  function initAccordions(){
    [].slice.call(document.querySelectorAll('[data-accordion]')).forEach(function(group){
      var items = [].slice.call(group.querySelectorAll('[data-accordion-item]'));
      items.forEach(function(item){
        var head = item.querySelector('[data-accordion-head]');
        var body = item.querySelector('[data-accordion-body]');
        var mark = item.querySelector('[data-accordion-mark]');
        if(!head||!body) return;
        body.style.overflow='hidden';
        body.style.transition='max-height .5s ease, opacity .5s ease, padding .5s ease';
        function set(open){
          if(open){ body.style.maxHeight = body.scrollHeight + 'px'; body.style.opacity='1'; if(mark) mark.textContent='–'; item.setAttribute('data-open','true'); }
          else { body.style.maxHeight='0px'; body.style.opacity='0'; if(mark) mark.textContent='+'; item.setAttribute('data-open','false'); }
        }
        set(item.getAttribute('data-open')==='true');
        head.addEventListener('click', function(){
          var isOpen = item.getAttribute('data-open')==='true';
          items.forEach(function(o){ if(o!==item){ var b=o.querySelector('[data-accordion-body]'); var m=o.querySelector('[data-accordion-mark]'); if(b){b.style.maxHeight='0px';b.style.opacity='0';} if(m)m.textContent='+'; o.setAttribute('data-open','false'); } });
          set(!isOpen);
        });
      });
    });
  }

  /* ---------- Testimonial rotation ---------- */
  function initTestimonials(){
    [].slice.call(document.querySelectorAll('[data-testimonials]')).forEach(function(root){
      var slides = [].slice.call(root.querySelectorAll('[data-testimonial-slide]'));
      var dots = [].slice.call(root.querySelectorAll('[data-testimonial-dot]'));
      if(slides.length<2) return;
      var i=0, timer;
      function show(n){
        i=n;
        slides.forEach(function(s,x){ s.style.display = x===n?'block':'none'; });
        dots.forEach(function(d,x){ d.style.width = x===n?'26px':'6px'; d.style.opacity = x===n?'1':'0.4'; });
      }
      function next(){ show((i+1)%slides.length); }
      function start(){ timer=setInterval(next,5200); }
      dots.forEach(function(d,x){ d.addEventListener('click', function(){ clearInterval(timer); show(x); start(); }); });
      show(0); start();
    });
  }

  /* ---------- Collection filter tabs ---------- */
  function initFilters(){
    [].slice.call(document.querySelectorAll('[data-filter-tabs]')).forEach(function(tabs){
      var grid = document.querySelector(tabs.getAttribute('data-target')||'[data-filter-grid]');
      [].slice.call(tabs.querySelectorAll('[data-filter]')).forEach(function(btn){
        btn.addEventListener('click', function(){
          var val = btn.getAttribute('data-filter');
          [].slice.call(tabs.querySelectorAll('[data-filter]')).forEach(function(b){ b.style.boxShadow='none'; b.style.opacity='0.55'; });
          btn.style.boxShadow='inset 0 -2px 0 #1C1A16'; btn.style.opacity='1';
          if(!grid) return;
          [].slice.call(grid.querySelectorAll('[data-filter-item]')).forEach(function(card){
            var t = card.getAttribute('data-type')||'';
            card.style.display = (val==='all'||t===val)?'':'none';
          });
        });
      });
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu(){
    var menu = document.querySelector('.aro-mobile-menu');
    [].slice.call(document.querySelectorAll('[data-menu-toggle]')).forEach(function(b){
      b.addEventListener('click', function(){ if(menu) menu.classList.toggle('open'); });
    });
    if(menu){ [].slice.call(menu.querySelectorAll('a')).forEach(function(a){ a.addEventListener('click', function(){ menu.classList.remove('open'); }); }); }
  }

  /* ---------- Toast ---------- */
  function toast(msg){
    var t = document.getElementById('aro-toast');
    if(!t){ t=document.createElement('div'); t.id='aro-toast'; document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._timer); t._timer=setTimeout(function(){ t.classList.remove('show'); }, 2200);
  }
  window.aromalaToast = toast;

  /* ---------- Qty steppers ---------- */
  function initQty(){
    [].slice.call(document.querySelectorAll('[data-qty]')).forEach(function(wrap){
      var input = wrap.querySelector('input');
      var dec = wrap.querySelector('[data-qty-dec]');
      var inc = wrap.querySelector('[data-qty-inc]');
      if(dec) dec.addEventListener('click', function(){ var v=Math.max(1,(parseInt(input.value,10)||1)-1); input.value=v; input.dispatchEvent(new Event('change',{bubbles:true})); });
      if(inc) inc.addEventListener('click', function(){ var v=Math.min(99,(parseInt(input.value,10)||1)+1); input.value=v; input.dispatchEvent(new Event('change',{bubbles:true})); });
    });
  }

  /* ---------- Add to cart (AJAX) ---------- */
  function initAddToCart(){
    [].slice.call(document.querySelectorAll('form[action$="/cart/add"], form[data-product-form]')).forEach(function(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var fd = new FormData(form);
        fetch((CFG.cartUrl? '' : '') + '/cart/add.js', { method:'POST', body: fd, headers:{'X-Requested-With':'XMLHttpRequest'} })
          .then(function(r){ return r.json(); })
          .then(function(){
            if(btn){ var orig=btn.getAttribute('data-label')||btn.textContent; btn.setAttribute('data-label',orig); btn.textContent='Added ✓ — Add again'; setTimeout(function(){ btn.textContent=orig; }, 2600); }
            toast('Added to cart');
            refreshCartCount();
          })
          .catch(function(){ toast('Could not add — try again'); });
      });
    });
  }

  function refreshCartCount(){
    fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}}).then(function(r){return r.json();}).then(function(c){
      [].slice.call(document.querySelectorAll('[data-cart-count]')).forEach(function(el){ el.textContent=c.item_count; });
    });
  }

  /* ---------- Quick add (card "Add" buttons outside a form, e.g. homepage protocol cards) ---------- */
  function initQuickAdd(){
    [].slice.call(document.querySelectorAll('[data-quick-add]')).forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var variantId = btn.getAttribute('data-variant-id');
        if(!variantId) return;
        var orig = btn.textContent;
        var reloadAfter = btn.hasAttribute('data-reload-after-add');
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function(){
            btn.textContent = 'Added ✓';
            toast('Added to cart');
            refreshCartCount();
            if(reloadAfter){
              /* Cart page's line items and totals are server-rendered — a plain AJAX
                 add leaves the visible list stale until the page reloads. */
              setTimeout(function(){ window.location.reload(); }, 500);
            } else {
              setTimeout(function(){ btn.textContent = orig; btn.disabled = false; }, 2200);
            }
          })
          .catch(function(){
            toast('Could not add — try again');
            btn.disabled = false;
          });
      });
    });
  }

  /* ---------- Deep-link hash scroll (sticky offset) ---------- */
  function initHashScroll(){
    function go(hash){
      if(!hash) return;
      var el = document.querySelector(hash);
      if(el){ var y = el.getBoundingClientRect().top + window.scrollY - 80; window.scrollTo({top:y, behavior:'smooth'}); }
    }
    if(location.hash) setTimeout(function(){ go(location.hash); }, 300);
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if(a){ var h=a.getAttribute('href'); if(h.length>1){ e.preventDefault(); go(h); history.pushState(null,'',h); } }
    });
  }

  ready(function(){
    initReveal(); initNavFrost(); initHero(); initMagnetic(); initAccordions();
    initTestimonials(); initFilters(); initMobileMenu(); initQty(); initAddToCart(); initQuickAdd();
    initHashScroll(); refreshCartCount();
  });
})();
